// Model
import { LocationModel } from './location.model';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';

export class MapViewConfigModel {

	public mapKey = '';

	// Default USA Position
	public defaultMapCenter = {
		latitude: 37.7542163,
		longitude: -108.2568741
	};

	public options: google.maps.MapOptions = {
		mapTypeId: 'satellite',
		fullscreenControl: false,
		mapTypeControl: true,
		streetViewControl: true,
		scrollwheel: true,
		maxZoom: 21
	}

	public mainLocation: { location?: google.maps.LatLngLiteral, icon?: string } = {};

	public centerLocation: google.maps.LatLngLiteral;

	public selectedLocationModel = null;
	public locationModels: LocationModel[] = [];

	/**
	 * Set the map key
	 *
	 * @param key
	 */
	public setMapKey(key: string): void {
		this.mapKey = key;
	}

	/**
	 * Set the Main Location
	 * @param mainPosition
	 */
	public setMainLocation(mainLocation: { latitude: number, longitude: number }, icon = null): void {
		// If Maps main coordinates are Missing, we center the map at USA
		if (
			!mainLocation ||
			mainLocation.latitude === null ||
			(
				mainLocation.latitude &&
				mainLocation.latitude.toString() === ''
			)
		) {
			// It defaults to USA Map
			this.mainLocation.location = {
				lat: this.defaultMapCenter.latitude,
				lng: this.defaultMapCenter.longitude
			};
		} else {
			this.mainLocation.location = {
				lat: mainLocation.latitude,
				lng: mainLocation.longitude
			};
		}
		this.mainLocation.icon = icon;
	}

	public setMarker(markerLocation: { latitude: number, longitude: number }, icon = null): void {
		this.locationModels.push({
			position: {
				lat: markerLocation.latitude,
				lng: markerLocation.longitude
			},
			iconUrl: icon
		});
	}

	public setOptions(newOptions: {
		mapTypeId?: string,
		fullscreenControl?: boolean,
		mapTypeControl?: boolean,
		streetViewControl?: boolean,
		scrollwheel?: boolean,
		maxZoom?: number
	}) {
		this.options = Object.assign(this.options, newOptions)
	}

	/**
	 * Add locations
	 * @param locations
	 */
	public setLocations(locations: LocationModel[]): void {
		this.locationModels.push(...locations);
	}

	/**
	 * Add a New Location, it avoids the entire map to reload
	 * @param locations
	 */
	public addLocation(locations: LocationModel[]): void {
		this.locationModels = this.locationModels.concat(locations);
	}

	/**
	 * Since the server now support Remove elements, the index variation can affect which element refer the image
	 * , it replaces an entire set for one type to avoids to re-render the entire map
	 * @param order
	 * @param photos
	 * @param locationPhotoUtilsService
	 */
	public updateLocations(): void {
		this.locationModels = this.locationModels.filter((locationModel: LocationModel) => {
			return !(locationModel.property.enumType && locationModel.property.enumType.Key === 'SMART_TAG_LOCATION')
		});
	}

	/**
	 * On Marker Click
	 * @param event
	 */
	public markerClicked(marker: MapMarker, infoWindow: MapInfoWindow, selectedLocationModel: any): void {
		if (selectedLocationModel.property) {
			infoWindow.open(marker);
			// Select new Photo
			this.selectedLocationModel = selectedLocationModel;
		}
	}
}
